import { catchError } from 'rxjs/operators';
import { Observable, EMPTY } from 'rxjs';
import { ErrorService } from '@app/services/error.service';

export function handleError<T>(
  errorService?: ErrorService,
): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>) =>
    source.pipe(
      catchError((error: Error): Observable<T> => {
        console.log(error.message || error);
        errorService?.showCommonError();
        return EMPTY;
      }),
    );
}
